<template>
  <div class="DetailsRight">
    <!-- 选项卡 -->
    <div class="tab_title flex_jc_center flex_ai_center">
      <div class="flex flex_jc_sb tabl border_right">
        <div class="rental_information flex_ai_center flex_jc_center tab_bgcolor">店铺机械</div>
        <div class="rental_information flex_ai_center flex_jc_center">企业资质与简介</div>
      </div>
    </div>
    <!-- 选择类型 -->
    <div class="classify">
      <div class="flex flex_jc_sb">
        <div class="all flex_ai_center margingB30">全部机械</div>
        <ul class="filtrate flex_jc_sb">
          <li class="flex_ai_center listBgColor">挖掘机</li>
          <li class="flex_ai_center">挖掘机</li>
          <li class="flex_ai_center">挖掘机</li>
          <li class="flex_ai_center">挖掘机</li>
          <li class="flex_ai_center">挖掘机</li>
          <li class="flex_ai_center">挖掘机</li>
          <li class="flex_ai_center">挖掘机</li>
        </ul>
      </div>
      <div class="flex flex_jc_sb">
        <div class="all flex_ai_center">全部机械</div>
        <ul class="filtrate flex_jc_sb">
          <li class="flex_ai_center listBgColor">挖掘机</li>
          <li class="flex_ai_center">挖掘机</li>
          <li class="flex_ai_center">挖掘机</li>
          <li class="flex_ai_center">挖掘机</li>
          <li class="flex_ai_center">挖掘机</li>
          <li class="flex_ai_center">挖掘机</li>
          <li class="flex_ai_center">挖掘机</li>
        </ul>
      </div>
    </div>
    <!-- 排序 -->
    <div class="rank">
      <div class="flex flex_jc_sb">
        <div class="price flex_jc_center flex_ai_center rankBgColr rankLeftRadius">价格排序</div>
        <div class="page_view flex_jc_center flex_ai_center rankRightRadius rankRightBorder">浏览量排序</div>
      </div>
    </div>
    <!-- 列表信息 -->
    <ul class="leaseList">
      <li class="floatL"
          v-for="(list,index) in leaseListArr"
          :key="index" v-on:click="goRentalInformationView()">
        <div class="img_container">
          <img src=""
               alt="">
          <div class="position_address flex flex_jc_sb flex_ai_center">
            <i class="el-icon-location"></i>
            <span>{{list.addresProvince}}&nbsp;&nbsp;{{list.addresCity}}&nbsp;&nbsp;{{list.addresDistrict}}</span>
          </div>
        </div>
        <div class="description">
          <p class="description_title">{{list.descriptionTitle}}</p>
          <div class="flex flex_jc_sb brand_model">
            <div>
              <span>品牌：</span>
              <span class="colorBlack">{{list.trademark}}</span>
            </div>
            <div>
              <span>型号：</span>
              <span class="colorBlack">{{list.modelNumber}}</span>
            </div>
          </div>
          <p class="time">{{list.time}}</p>
          <div class="flex flex_jc_sb price">
            <span class="flex_ai_center">{{list.price}}/月</span>
            <img src="" />
          </div>
          <div class="shade"></div>
        </div>
        <div class="platform_recommend flex_ai_center flex_jc_center">平台推荐</div>
      </li>
      <div class="clearB"></div>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'DetailsRight',
  components: {},
  data () {
    return {
      leaseListArr: [
        {
          img: '../../../../static/img/rentalInformationList/1.jpg',
          addresProvince: '新疆',
          addresCity: '乌鲁木齐',
          addresDistrict: '水磨沟区',
          descriptionTitle: '放声大哭帮您反馈是你发你圣诞快乐愤怒地说可能付款的时间',
          trademark: '徐工',
          modelNumber: 'Y321',
          time: '2018-10-25',
          price: '6666'
        },
        {
          img: '../../../../static/img/rentalInformationList/1.jpg',
          addresProvince: '新疆',
          addresCity: '乌鲁木齐',
          addresDistrict: '水磨沟区',
          descriptionTitle: '放声大哭帮您反馈是你发你圣诞快乐愤怒地说可能付款的时间',
          trademark: '徐工',
          modelNumber: 'Y321',
          time: '2018-10-25',
          price: '6666'
        },
        {
          img: '../../../../static/img/rentalInformationList/1.jpg',
          addresProvince: '新疆',
          addresCity: '乌鲁木齐',
          addresDistrict: '水磨沟区',
          descriptionTitle: '放声大哭帮您反馈是你发你圣诞快乐愤怒地说可能付款的时间',
          trademark: '徐工',
          modelNumber: 'Y321',
          time: '2018-10-25',
          price: '6666'
        },
        {
          img: '../../../../static/img/rentalInformationList/1.jpg',
          addresProvince: '新疆',
          addresCity: '乌鲁木齐',
          addresDistrict: '水磨沟区',
          descriptionTitle: '放声大哭帮您反馈是你发你圣诞快乐愤怒地说可能付款的时间',
          trademark: '徐工',
          modelNumber: 'Y321',
          time: '2018-10-25',
          price: '6666'
        },
        {
          img: '../../../../static/img/rentalInformationList/1.jpg',
          addresProvince: '新疆',
          addresCity: '乌鲁木齐',
          addresDistrict: '水磨沟区',
          descriptionTitle: '放声大哭帮您反馈是你发你圣诞快乐愤怒地说可能付款的时间',
          trademark: '徐工',
          modelNumber: 'Y321',
          time: '2018-10-25',
          price: '6666'
        },
        {
          img: '../../../../static/img/rentalInformationList/1.jpg',
          addresProvince: '新疆',
          addresCity: '乌鲁木齐',
          addresDistrict: '水磨沟区',
          descriptionTitle: '放声大哭帮您反馈是你发你圣诞快乐愤怒地说可能付款的时间',
          trademark: '徐工',
          modelNumber: 'Y321',
          time: '2018-10-25',
          price: '6666'
        },
        {
          img: '../../../../static/img/rentalInformationList/1.jpg',
          addresProvince: '新疆',
          addresCity: '乌鲁木齐',
          addresDistrict: '水磨沟区',
          descriptionTitle: '放声大哭帮您反馈是你发你圣诞快乐愤怒地说可能付款的时间',
          trademark: '徐工',
          modelNumber: 'Y321',
          time: '2018-10-25',
          price: '6666'
        },
        {
          img: '../../../../static/img/rentalInformationList/1.jpg',
          addresProvince: '新疆',
          addresCity: '乌鲁木齐',
          addresDistrict: '水磨沟区',
          descriptionTitle: '放声大哭帮您反馈是你发你圣诞快乐愤怒地说可能付款的时间',
          trademark: '徐工',
          modelNumber: 'Y321',
          time: '2018-10-25',
          price: '6666'
        },
        {
          img: '../../../../static/img/rentalInformationList/1.jpg',
          addresProvince: '新疆',
          addresCity: '乌鲁木齐',
          addresDistrict: '水磨沟区',
          descriptionTitle: '放声大哭帮您反馈是你发你圣诞快乐愤怒地说可能付款的时间',
          trademark: '徐工',
          modelNumber: 'Y321',
          time: '2018-10-25',
          price: '6666'
        },
        {
          img: '../../../../static/img/rentalInformationList/1.jpg',
          addresProvince: '新疆',
          addresCity: '乌鲁木齐',
          addresDistrict: '水磨沟区',
          descriptionTitle: '放声大哭帮您反馈是你发你圣诞快乐愤怒地说可能付款的时间',
          trademark: '徐工',
          modelNumber: 'Y321',
          time: '2018-10-25',
          price: '6666'
        },
        {
          img: '../../../../static/img/rentalInformationList/1.jpg',
          addresProvince: '新疆',
          addresCity: '乌鲁木齐',
          addresDistrict: '水磨沟区',
          descriptionTitle: '放声大哭帮您反馈是你发你圣诞快乐愤怒地说可能付款的时间',
          trademark: '徐工',
          modelNumber: 'Y321',
          time: '2018-10-25',
          price: '6666'
        },
        {
          img: '../../../../static/img/rentalInformationList/1.jpg',
          addresProvince: '新疆',
          addresCity: '乌鲁木齐',
          addresDistrict: '水磨沟区',
          descriptionTitle: '放声大哭帮您反馈是你发你圣诞快乐愤怒地说可能付款的时间',
          trademark: '徐工',
          modelNumber: 'Y321',
          time: '2018-10-25',
          price: '6666'
        }
      ]
    }
  },
  mounted () {},
  // 方法
  methods: {
    goRentalInformationView () {
      this.$router.push({ path: `/storeInformationManagement` })
    }
  },
  watch: {

  },
  created () {}
}
</script>

<style  lang="scss" rel="stylesheet/scss" scoped>
.DetailsRight {
  width: 68%;
  background: #ffffff;
  border: 1px solid #e0e5ea;
  border-radius: 10px;
  margin-bottom: 50px;
  .tab_title {
    width: 100%;
    height: 120px;
    .tabl {
      width: 265px;
      height: 40px;
      margin: 0 auto;
      border-top: 1px solid #c9c9c9;
      border-bottom: 1px solid #c9c9c9;
      border-radius: 40px;
    }
    .rental_information {
      width: 50%;
      box-sizing: border-box;
      height: 40px;
      font-size: 16px;
      cursor: pointer;
      color: #5a5a5a;
    }
  }
  .classify {
    width: 100%;
    background: #faf6f3;
    padding: 25px 75px;
    box-sizing: border-box;
    .all {
      width: 10%;
      height: 30px;
      font-size: 14px;
      color: #6d6c6c;
    }
    .filtrate {
      width: 90%;
      margin: 0;
      padding: 0;
      list-style-type: none;
      li {
        height: 30px;
        padding: 0 20px;
        font-size: 14px;
        color: #6d6c6c;
      }
    }
  }
  .rank {
    width: 100%;
    padding: 30px 20px;
    box-sizing: border-box;
    > div {
      width: 180px;
      height: 45px;
      div {
        width: 90px;
        height: 45px;
        font-size: 14px;
        color: #676767;
        box-sizing: border-box;
        cursor: pointer;
      }
    }
  }
  .rankBgColr {
    background: #ff8b00;
    color: #ffffff !important;
  }
  .rankLeftRadius {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }
  .rankRightRadius {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  .rankLeftBorder {
    border-top: 1px solid #e0e5eb;
    border-bottom: 1px solid #e0e5eb;
    border-left: 1px solid #e0e5eb;
  }
  .rankRightBorder {
    border-top: 1px solid #e0e5eb;
    border-bottom: 1px solid #e0e5eb;
    border-right: 1px solid #e0e5eb;
  }
  .leaseList {
    width: 100%;
    background: #f6f6f6;
    list-style-type: none;
    margin: 0;
    padding: 0 20px 30px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    box-sizing: border-box;
    > li {
      width: 31.33333333%;
      margin-right: 2%;
      margin-bottom: 30px;
      background: #ffffff;
      border-radius: 10px;
      cursor: pointer;
      .img_container {
        width: 100%;
        position: relative;
        img {
          width: 100%;
          height: 197.3px;
          border-top-right-radius: 10px;
          border-top-left-radius: 10px;
        }
        .position_address {
          width: 100%;
          height: 40px;
          position: absolute;
          padding: 0 20px;
          background: rgba(103, 103, 103, 0.5);
          left: 0;
          bottom: 4px;
          box-sizing: border-box;
          i,
          span {
            color: #ffffff;
          }
          span {
            display: inline-block;
            margin-left: 10px;
            height: 40px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: 40px;
          }
        }
      }
      .description {
          width: 100%;
          padding: 20px;
          box-sizing: border-box;
          position: relative;
          p.description_title {
              font-size: 14px;
              font-weight: bolder;
              height: 38px;
              overflow: hidden;
          }
          .brand_model {
              width: 175px;
              margin: 8px 0;
              font-size: 14px;
              color: #7B7B7B;
              span.colorBlack {
                  color: #000000;
                  font-weight: bolder;
              }
          }
          p.time {
              font-size:14px;
              color: #949494;
              margin-bottom: 8px;
          }
          .price {
              span {
                  font-size: 14px;
                  color: #FF601E
              }
              img {
                  width: 30px;
                  height: 30px;
              }
          }
          .shade {
            position: absolute;
            width: 100%;
            height: 102%;
            top: -4px;
            left: 0;
            background: rgba(0, 0, 0, 0.2);
            z-index: 2;
            display: none;
          }
      }
      .platform_recommend {
          position: absolute;
          width: 115px;
          height: 40px;
          top: 0;
          right: 0;
          background: #FF8B00;
          font-size: 14px;
          color: #ffffff;
          border-top-right-radius: 10px;
          border-bottom-left-radius: 10px;
      }
    }
    >li:hover .shade{
      display: block;
    }
    > li:nth-of-type(3n) {
      margin-right: 0;
    }
  }
  .margingB30 {
    margin-bottom: 30px;
  }
  .border_left {
    border-left: 1px solid #c9c9c9;
  }
  .border_right {
    border-right: 1px solid #c9c9c9;
  }
  .tab_bgcolor {
    background: #ff8b00 !important;
    color: #ffffff !important;
    border-right: 1px solid #c9c9c9;
    border-left: 1px solid #c9c9c9;
    border-radius: 40px;
  }
  .listBgColor {
    background: #ff8b00 !important;
    color: #ffffff !important;
    border-radius: 6px;
  }
  .floatL {
    float: left;
  }
  .clearB {
    clear: both;
  }
}
</style>
